import _ from 'lodash';
import moment from 'moment';
import React, { Fragment } from 'react';
import { observer, inject } from 'mobx-react';

import SongList from './song-list';

@inject('songsStore')
@observer
export default class Library
extends React.Component {
	render () {
		const { songsStore, member } = this.props;

		if (_.isEmpty(member.hiFived)) {

			return (
				<div className="cell small-12 text-center" style={{marginTop:'20vh'}}>
					<div className="no-result-text dropfade-text">No favorite songs have been added yet.</div>
					<div className="no-result-text dropfade-subtext margin-top-1" style={{fontSize:'1.25em'}}>Why not get out there and add some?</div>

				</div>
			);
		}

		const songs = member.hiFived.map(
			({ itemID }) => songsStore.getItemByID(itemID)
		);

		return (
			<Fragment>
				<h4 className="subheader">
					{ member.firstNamePlural } Favorites
				</h4>

				<SongList songList={ songs } />
			</Fragment>
		);
	}
}
